import { render, staticRenderFns } from "./BarcodeReturn.vue?vue&type=template&id=1b4e7d47&scoped=true"
import script from "./BarcodeReturn.vue?vue&type=script&lang=js"
export * from "./BarcodeReturn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b4e7d47",
  null
  
)

export default component.exports